/**
 * Valores iniciais do formulário de Role/Cargo.
 */
export const roleDefaults = {
    name: "",
    description: "",
    status: "active",
    permissions: {},

    // ─── Performance & Métricas ───
    // Define qual grupo de métricas aplica a este cargo para o módulo de ranking.
    // "professor" = métricas de aula, frequência, conversão de experimentais (Colaborador Responsável pela turma)
    // "consultor" = métricas de vendas, renovações, faturamento, CRM (Consultor(a) de vendas)
    // "gerente"   = métricas macro de receita, retenção e crescimento (Gestão)
    // ""          = não participa do ranking
    metricGroup: "",
};
